import { useCallback } from 'react';

import { FamilyTreeActionFn, MarriageLayoutComputedAction } from '../types';

export function useMarriageLayoutComputedAction() {
  return useCallback<FamilyTreeActionFn<MarriageLayoutComputedAction>>(
    (state, action, queueEffect) => {
      if (!action.isAutoPosition) {
        queueEffect({ type: 'fitViewEffect' });
        queueEffect({ type: 'completeInitializationEffect' });

        return {
          ...state,
          nodes: action.layoutNodes,
          edges: action.layoutEdges,
        };
      } else {
        queueEffect({ type: 'fitViewEffect' });
        // Note: Don't save immediately when auto-positioning.
        // The user must click "Done" to save, or "Cancel" to discard.
        // This respects the expected trowser transactional behavior.

        const positionsById = new Map(
          action.layoutNodes.map((node) => [node.id, node.position])
        );

        const newNodes = state.nodes.map((node) => ({
          ...node,
          position: positionsById.get(node.id) ?? node.position,
        }));

        // Don't exit edit mode - user is still editing and needs to save/cancel
        return {
          ...state,
          nodes: newNodes,
          hasUnsavedNodePositions: true,
          nodePositions: newNodes.map((node) => ({
            nodeID: node.id,
            xPosition: node.position.x,
            yPosition: node.position.y,
          })),
        };
      }
    },
    []
  );
}
